import { gql } from "config/graphql";

export const FEATURE_FLAG_FIELDS = gql`
  fragment FeatureFlagFields on FeatureFlag {
    enabled
    name
  }
`;
